import { render, staticRenderFns } from "./PropertyComplaintDialog.vue?vue&type=template&id=951e3fd6&scoped=true&"
import script from "./PropertyComplaintDialog.vue?vue&type=script&lang=js&"
export * from "./PropertyComplaintDialog.vue?vue&type=script&lang=js&"
import style0 from "./PropertyComplaintDialog.vue?vue&type=style&index=0&id=951e3fd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951e3fd6",
  null
  
)

export default component.exports